import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from '../../styles/mariana-images.css?inline';
import type { ImageItem } from '../chat/types.js';
import { sanitizeUrl, dispatchChatMarianaLinks } from '../../utils/chat-utils.js';


@customElement('mariana-images')
export class MarianaImages extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: Array })
  images: ImageItem[] = [];

  @property({ type: String })
  source = '';

  private handleImageLinkClick(e: Event, url: string) {
    if (!this.isAppCC) return;

    e.preventDefault();
    dispatchChatMarianaLinks(url);
  }

  private get isAppCC(): boolean {
    return this.source.toLowerCase() === 'appcc';
  }

  render() {
    if (!this.images || this.images.length === 0) {
      return html``;
    }

    return html`
      <div class="image-container">
        ${this.images.map((image) => html`
          <div class="image-item">
            ${image.link && sanitizeUrl(image.link)
        ? html`
                  <a
                    href="${sanitizeUrl(image.link)}"
                    target="_blank"
                    rel="noopener noreferrer"
                    @click=${(e: Event) => this.handleImageLinkClick(e, sanitizeUrl(image.link!))}
                  >
                    <img 
                      src="${sanitizeUrl(image.source) || ''}"
                      loading="lazy"
                    />
                  </a>
                `
        : html`
                  <img 
                    src="${sanitizeUrl(image.source) || ''}"
                    loading="lazy"
                  />
                `}
          </div>
        `)}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mariana-images': MarianaImages;
  }
}
